export default __webpack_public_path__ + "static/media/open_eye.f6cdcbe8.svg";